const returnToURLWhitelist = [
  'dashboard.bandwidth.com',
  'numbers-history-app.dashboard.bandwidth.com',
];

export default returnToURLWhitelist;
